export default __webpack_public_path__ + "static/media/logo.145882ba.png";